module.exports = __webpack_public_path__ + "static/media/EmotionalRegulationSystems.4f605f4d.svg";